import hotInd from "~/assets/cities/hot-ind.png";
import postCount from "~/assets/cities/post-count.png";
import hotIndsm from "~/assets/cities/hot-ind-sm.png";
import postCountsm from "~/assets/cities/post-count-sm.png";
import { Tag } from "antd";
import { FireOutlined } from "@ant-design/icons";

const CollaborationTags = ({ collaboration, className = "" }: any) => {
  const hotCount =
    collaboration.category.posts_count * 20 +
    collaboration.category.comments_count * 3 +
    collaboration.category.views_count;
  return (
    <div className={`collaboration-tag-wrapper ${className}`}>
      <div className="tag">
        <img src={hotInd.src} className="normal" />
        <img src={hotIndsm.src} className="small" />
        <span>热度</span>
        <span>
          {hotCount > 1000 ? `${(hotCount / 1000).toFixed(1)}k` : hotCount}
        </span>
      </div>
      <div className="tag">
        <img src={postCount.src} className="normal" />
        <img src={postCountsm.src} className="small" />
        <span>帖子</span>
        <span>{collaboration.category.posts_count}</span>
      </div>
    </div>
  );
};
export default CollaborationTags;
